// extracted by mini-css-extract-plugin
module.exports = {"accordion-details-root":"-hT5nhKMW1vYElnNjrctO","preLoaderShimmer":"_2vTlqPwyePCk6fuc5Z9hJ2"};